import { type ParliamentaryDay } from '@prisma/client'
import { useNavigate } from '@remix-run/react'
import { useState } from 'react'
import { Calendar as CalendarComponent } from '#app/components/ui/calendar'

const zeroPad = (num: number) => num.toString().padStart(2, '0')

const getDate = (date: Date) =>
  `${date.getFullYear()}-${zeroPad(date.getMonth() + 1)}-${zeroPad(date.getDate())}`

export default function Calendar({
  day,
  allDays,
}: {
  day: string
  allDays: ParliamentaryDay[]
}) {
  const navigate = useNavigate()

  const [selectedDay, setSelectedDay] = useState(day)

  const isDisabled = (date: Date) => {
    const day = getDate(date)
    console.log('day', day)
    return !allDays.find(d => d.id === day)
  }

  const onSelect = (date?: Date) => {
    if (!date) return

    const day = getDate(date)
    if (allDays.find(d => d.id === day)) {
      setSelectedDay(day)
      navigate(`/hansard/${day}`)
    }
  }

  return (
    <CalendarComponent
      mode="single"
      selected={new Date(selectedDay)}
      defaultMonth={new Date(day)}
      onSelect={onSelect}
      disabled={isDisabled}
    />
  )
}
